import { render, staticRenderFns } from "./StandardEventsFeedWidget.vue?vue&type=template&id=70ce6d22&"
import script from "./StandardEventsFeedWidget.vue?vue&type=script&lang=js&"
export * from "./StandardEventsFeedWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70ce6d22')) {
      api.createRecord('70ce6d22', component.options)
    } else {
      api.reload('70ce6d22', component.options)
    }
    module.hot.accept("./StandardEventsFeedWidget.vue?vue&type=template&id=70ce6d22&", function () {
      api.rerender('70ce6d22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dynamic-list-items/widgets/feeds/StandardEventsFeedWidget.vue"
export default component.exports